<!--
程序名：问题设计页面
功能：对问卷中问题的添加、编辑、删除
-->
<template>
  <div class="Design" v-loading="loading" element-loading-text="加载中...">
    <h3>{{ title }}</h3>
    <div class="top" v-if="desc!=''">
      {{ desc }}
    </div>
    <el-card class="box-card" v-for="(item,index) in detail" style="margin: 10px;">
      <div slot="header" class="clearfix">
        <div class="questionTitle">
          <!--显示必填标识-->
          <span style="color: #F56C6C;">
              <span v-if="item.requiredFlag">*</span>
              <span v-else>&nbsp;</span>
            </span>
          <span style="color: black;margin-right: 3px;">{{ (index + 1) + '.' }}</span>
          {{ item.questionDescription }}
        </div>
        <div style="float: right;">
          <el-button style="padding: 2px" type="text" @click="editorQuestion(item)">编辑</el-button>
          <el-button style="padding: 2px;color: #F56C6C" type="text" @click="deleteQuestion(index)">删除</el-button>
        </div>
      </div>
      <!--单选题展示-->
      <div v-if="item.optionList.length>0">
      <div class="text item" v-if="item.questionType==='1'" v-for="(option,index) in item.optionList">
        <el-radio v-model="item.radioValue" :label="option.optionId" style="margin: 5px;">{{
            option.optionName
          }}
        </el-radio>
      </div>
      <!--多选题展示-->
      <el-checkbox-group v-if="item.questionType==='2'" v-model="item.checkboxValue">
        <div class="text item" v-for="(option,index) in item.optionList">
          <el-checkbox :label="option.optionId" style="margin: 5px;">{{ option.optionName }}</el-checkbox>
        </div>
      </el-checkbox-group>
      </div>
      <!--填空题展示-->
      <el-input
        v-if="item.questionType==='3'"
        type="textarea"

        resize="none"
        v-model="item.textValue">
      </el-input>
      <!--      :rows="item.row"-->
    </el-card>

    <el-button icon="el-icon-circle-plus" @click="addQuestion" style="margin-top: 10px;">添加题目</el-button>

    <br><br><br><br><br>

    <!--添加题目弹窗-->
    <el-dialog :title="dialogTitle" :visible.sync="dialogShow" :close-on-click-modal="false" class="dialog">
      <el-form ref="form" :model="willAddQuestion" label-width="100px">
        <el-form-item label="题目类型" style="width: 100%;">
          <el-select v-model="willAddQuestion.type" placeholder="请选择题目类型" @change="typeChange">
            <el-option
              v-for="item in allType"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否必填" style="width: 100%;">
          <el-checkbox v-model="willAddQuestion.must">必填</el-checkbox>
        </el-form-item>
        <el-form-item label="是否为子问题" style="width: 100%;">
          <el-checkbox v-model="willAddQuestion.hasSon"></el-checkbox>
        </el-form-item>
        <el-form-item v-if="willAddQuestion.hasSon" label="绑定的问题" style="width: 100%;">
          <div>
            <el-select v-model="selectedQuestionId" filterable placeholder="请选择" @change="changeQuestionId">
              <el-option
                v-for="(item,index) in detail"
                :key="index"
                :label="item.questionDescription"
                :value="index">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item v-if="willAddQuestion.hasSon&&selectedQuestionId!==null" label="绑定的选项" style="width: 100%;">
          <div>
            <el-select v-model="selectedOptionId" filterable placeholder="请选择"
                       v-if="detail[selectedQuestionId].optionList.length>0">
              <el-option
                v-for="(item,index) in detail[selectedQuestionId].optionList"
                :key="index"
                :label="item.optionName"
                :value="item.optionId">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="题目标题" style="width: 100%;">
          <el-input v-model="willAddQuestion.title" placeholder="请输入标题"></el-input>
        </el-form-item>

        <template v-if="willAddQuestion.type==='1'||willAddQuestion.type==='2'">
          <el-form-item :label="'选项'+(index+1)" v-for="(item,index) in willAddQuestion.options">
            <el-row>
              <el-col :span="16">
                <el-input v-model="item.optionName" placeholder="请输入选项名" style="width: 90%;"></el-input>
              </el-col>
              <el-col :span="8">
                <el-row>
                  <!--                  <el-col :span="12">-->
                  <!--                    <el-button v-if="dialogTitle==='编辑问题'" type="primary" plain size="small"-->
                  <!--                               @click="addSonQuestion(item)">添加子问题-->
                  <!--                    </el-button>-->
                  <!--                  </el-col>-->
                  <el-col :span="12">
                    <el-button type="danger" size="small" style="margin-left: 25px" plain class=""
                               @click="deleteOption(index)">删除选项
                    </el-button>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-form-item>
          <el-button type="success" plain class="addOptionButton" @click="addOption">新增选项</el-button>
        </template>
        <template v-if="willAddQuestion.type==='3'">

        </template>
      </el-form>
      <el-dialog
        width="60%"
        title="添加子问题"
        :visible.sync="innerVisible"
        append-to-body>
        <el-form ref="form1" :model="sonQuestion" label-width="80px">
          <el-form-item label="题目类型" style="width: 100%;">
            <el-select v-model="sonQuestion.type" placeholder="请选择题目类型" @change="typeChange">
              <el-option
                v-for="item in allType"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否必填" style="width: 100%;">
            <el-checkbox v-model="sonQuestion.must">必填</el-checkbox>
          </el-form-item>
          <el-form-item label="题目标题" style="width: 100%;">
            <el-input v-model="sonQuestion.title" placeholder="请输入标题"></el-input>
          </el-form-item>

          <template v-if="sonQuestion.type==='1'||sonQuestion.type==='2'">
            <el-form-item :label="'选项'+(index+1)" v-for="(item,index) in sonQuestion.options">
              <el-row>
                <el-col :span="16">
                  <el-input v-model="item.optionName" placeholder="请输入选项名" style="width: 90%;"></el-input>
                </el-col>
                <el-col :span="8">
                  <el-button type="danger" size="small" style="margin-left: 25px" plain class=""
                             @click="deleteOption(index)">删除选项
                  </el-button>
                </el-col>
              </el-row>
            </el-form-item>
            <el-button type="success" plain class="addOptionButton" @click="addOption">新增选项</el-button>
          </template>
          <template v-if="sonQuestion.type==='3'">
          </template>
        </el-form>
        <div style="width: 100%;text-align: right">
          <el-button style="margin-left: 10px;" @click="innerVisible=false">取消</el-button>
          <el-button type="primary" style="margin-left: 10px;" @click="checkAddSonQuestion">完成</el-button>
        </div>
      </el-dialog>
      <br>
      <div style="width: 100%;text-align: right">
        <el-button style="margin-left: 10px;" @click="dialogShow=false">取消</el-button>
        <el-button type="primary" style="margin-left: 10px;" @click="checkAddQuestion">完成</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import {designOpera} from './api'
export default {
  data() {
    return {
      optionId: 0,
      selectedQuestionId: null,
      selectedOptionId: null,
      innerVisible: false,
      sonQuestion: {
        options: [
          {
            optionName: '',//选项标题
          }
        ],
      },
      loading: false,//页面加载中
      dialogShow: false,
      dialogTitle: '',
      detail: [],
      wjId: 0,
      title: '',
      desc: '',
      willAddQuestion: {
        id: "Q1",
        type: '',
        title: '',
        options: [
          {
            optionName: '',//选项标题
            // optionSgin: 1//选项id
          }
        ],
        row: 1,
        must: 0,//是否必填
      },
      allType: [
        {
          value: '1',
          label: '单选题',
        },
        {
          value: '2',
          label: '多选题',
        },
        {
          value: '3',
          label: '填空题',
        },
      ],
    }
  },
  methods: {
    changeQuestionId() {
      // this.selectedQuestionId=null
      this.selectedOptionId = null
    },
    //添加子问题
    addSonQuestion(item) {
      this.optionId = item.optionId
      if (this.willAddQuestion.optionId !== 0) {
        this.sonQuestion.options = []
        //即为编辑
        this.sonQuestion.title = item.questionDescription;
        this.sonQuestion.type = item.questionType;
        // this.sonQuestion.options = JSON.parse(JSON.stringify(item.optionList));
        this.willAddQuestion.text = item.text;
        // this.willAddQuestion.row = item.row;
        this.sonQuestion.must = item.requiredFlag;
        this.sonQuestion.id = item.id;
        // this.dialogTitle = '编辑问题';
      } else {

      }
      this.innerVisible = true
    },

    //初始化问卷所有问题
    init(wjId, title, desc) {
      this.wjId = wjId;
      this.title = title;
      this.desc = desc;
      this.getQuestionList();
    },
    //获取问题列表(问卷内容)
    async getQuestionList() {
      // this.detail = [];
      this.loading = true;
      await this.$http.get("/survey/getSurveyInfo/" + this.wjId)
        .then(res => {
          this.detail = res.data.questionList.map(item => {
            return {
              ...item,
              radioValue: -1,
              checkboxValue: [],
              textValue: '',
              hasSon: false,
            }
          })
          this.loading = false;
        })
    },
    //点击添加问题按钮
    addQuestion() {
      if (this.wjId == 0 || this.wjId == null) {
        this.$messageUi({
          type: 'error',
          message: '请先创建问卷!'
        });
        return;
      }
      this.dialogTitle = '添加题目';
      this.willAddQuestion = {
        id: "Q1",
        type: '',
        title: '',
        hasSon: false,
        options: [
          {
            optionName: '',//选项标题
            // optionSgin: "1"//选项id
          },

        ],
        // row: 1,
        selectedQuestionId:null,
        must: 0,//是否必填
      };
      this.dialogShow = true;
    },

    //删除问题
    deleteQuestion(index) {
      this.$confirmUi('确定删除此题目?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // designOpera({
        //   opera_type: 'delete_question',
        //   username: 'test',
        //   questionId: this.detail[index].id,
        // })
        console.log(this.detail, this.wjId)
        this.$http.delete("/survey/delOneQuestion/" + this.wjId + '/' + this.detail[index].id)
          .then(data => {
            console.log(data);
            if (data.code === 200) {
              this.detail.splice(index, 1);
              this.$messageUi({
                type: 'success',
                message: '删除成功!'
              });
            } else {
              this.$messageUi({
                type: 'error',
                message: data.message
              });
            }
          })
      });

    },
    //确认添加/保存题目
    checkAddQuestion() {
      //添加保存问题
      let newItem = {};//新添加的问题对象
      newItem = {
        questionType: this.willAddQuestion.type,
        questionName: this.willAddQuestion.title,
        optionList: this.willAddQuestion.options,
        // row: this.willAddQuestion.row,
        requiredFlag: this.willAddQuestion.must,
      };
      newItem.radioValue = -1;
      newItem.checkboxValue = [];
      newItem.textValue = '';
      this.putQuestion()
    },
    checkAddSonQuestion() {
      let requiredFlag = "0"
      if (this.willAddQuestion.must) {
        requiredFlag = "1"
      }
      let sendData = {
        surveyId: this.wjId,
        questionName: "",
        questionDescription: this.sonQuestion.title,
        questionType: this.sonQuestion.type,
        optionList: this.sonQuestion.options,
        questionSort: 1,
        optionId: 0,
        // row: this.willAddQuestion.row,
        requiredFlag: requiredFlag
      }
      this.$http.post("/survey/addOneQuestion", sendData)
        .then(data => {
          console.log(data);
          // newItem.id = data.id;
          if (data.code === 200) {
            this.putQuestion()
            this.$messageUi({
              type: 'success',
              message: '保存成功!'
            });
          } else {
            this.innerVisible = false;
            this.$messageUi({
              type: 'error',
              message: data.message
            });
          }
        })
    },
    putQuestion() {
      let requiredFlag = "0"
      if (this.willAddQuestion.must) {
        requiredFlag = "1"
      }
      let optionId=null
      if(this.willAddQuestion.hasSon&&this.selectedQuestionId!==null){
        optionId=this.selectedOptionId
      }else {
        optionId=0
      }
      let sendData = {
        surveyId: this.wjId,
        questionName: "",
        questionDescription: this.willAddQuestion.title,
        questionType: this.willAddQuestion.type,
        optionList: this.willAddQuestion.options,
        questionSort: 1,
        optionId: optionId,
        // row: this.willAddQuestion.row,
        requiredFlag: requiredFlag
      }
      if (this.dialogTitle === '添加题目' && (!this.innerVisible)) {
        console.log(sendData, this.willAddQuestion.options)
        this.$http.post("/survey/addOneQuestion", sendData)
          .then(data => {
            // newItem.id = data.id;
            if (data.code === 200) {
              this.dialogShow = false;
              this.$messageUi({
                type: 'success',
                message: '保存成功!'
              });
              this.getQuestionList();
            } else {
              this.dialogShow = false;
              this.$messageUi({
                type: 'error',
                message: data.message
              });
            }
          });
      } else {
        sendData.id = this.willAddQuestion.id
        if (this.innerVisible) {
          sendData.optionId = this.optionId
        }
        this.$http({
          url: "/survey/updateOneQuestion",
          method: 'put',
          data: sendData
        }).then(data => {
          if (data.code === 200) {
            if (this.innerVisible) {
              this.innerVisible = false;
            } else {
              this.dialogShow = false;
              this.$messageUi({
                type: 'success',
                message: '保存成功!'
              });
              this.getQuestionList();
            }
          } else {
            this.dialogShow = false;
            this.$messageUi({
              type: 'error',
              message: data.message
            });
          }
        })
      }


    },

    //点击编辑问题按钮
    editorQuestion(item) {
      this.dialogShow = true;
      // this.willAddQuestion.title = item.questionDescription;
      // this.willAddQuestion.type = item.questionType;
      // this.willAddQuestion.optionList = JSON.parse(JSON.stringify(item.optionList));
      // this.willAddQuestion.text = item.text;
      // this.willAddQuestion.row = item.row;
      // this.willAddQuestion.requiredFlag = item.requiredFlag;
      // this.willAddQuestion.questionSort=1
      this.willAddQuestion.title = item.questionDescription;
      this.willAddQuestion.type = item.questionType;
      this.willAddQuestion.options = JSON.parse(JSON.stringify(item.optionList));
      this.willAddQuestion.optionId = item.optionId
      // this.willAddQuestion.text = item.text;
      // this.willAddQuestion.row = item.row;
      this.willAddQuestion.must = item.requiredFlag;
      this.willAddQuestion.id = item.id;
      this.dialogTitle = '编辑问题';
      // this.willAddQuestion.id = item.id;
      // this.dialogTitle = '编辑问题';

    },
    //添加选项
    addOption() {
      if (this.innerVisible) {
        console.log("there")
        this.sonQuestion.options.push({});
      } else {
        this.willAddQuestion.options.push({
          // title: '',
          // id: 0,
        });
      }

    },
    //删除选项
    deleteOption(index) {
      this.willAddQuestion.options.splice(index, 1);
    },
    //切换问题类型
    typeChange(value) {
      console.log(value);
      this.willAddQuestion.type = value;
      this.willAddQuestion.text = '';
      // this.row = 1;
    },
  }
}
</script>
<style scoped>
.Design {

}

.Design .dialog {
  text-align: left;
  /*min-width: 600px;*/
}

.Design .questionTitle {
  display: inline-block;
  width: 80%;
  font-size: 16px;
  color: #303133;
}

.Design .addOptionButton {
  display: inline-block;
  margin-left: 80px;
}

.box-card {
  width: 100%;
  text-align: left;
}

.Design .top {
  color: #606266;
  margin-left: 20px;
  padding: 0 10px 10px 10px;
  border-bottom: 3px solid #409EFF;
  font-size: 15px;
  line-height: 22px;
  text-align: left;
}
</style>
